var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-markdown',{class:[{ editable: !(_vm.editable === false) }, _vm.myClass],attrs:{"contenteditable":!(_vm.editable === false),"watches":['myContent'],"source":_vm.myContent,"linkify":false,"emoji":false},on:{"input":_vm.update}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05d5d9ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/explorer/editable-markdown.vue
// module id = a5wn
// module chunks = 1